import "./index.css"

export const Loader = ({ loading = false, color = "#FFFFFF" }) => {
    return loading ? (
        <div className="absolute top-0 left-0 z-10 w-full h-full bg-[rgba(0,0,0,0.2)] backdrop-blur-sm">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
                <radialGradient id="a11" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
                    <stop offset="0" stop-color={color}></stop>
                    <stop offset=".3" stop-color={color} stop-opacity=".9"></stop>
                    <stop offset=".6" stop-color={color} stop-opacity=".6"></stop>
                    <stop offset=".8" stop-color={color} stop-opacity=".3"></stop>
                    <stop offset="1" stop-color={color} stop-opacity="0"></stop>
                </radialGradient>
                <circle className="loader-rotation" fill="none" stroke="url(#a11)" stroke-width="1" stroke-linecap="round" stroke-dashoffset="0" cx="100" cy="60" r="4">
                </circle>
                <circle fill="none" opacity=".2" stroke={color} stroke-width="1" stroke-linecap="round" cx="100" cy="60" r="4">
                </circle>
            </svg>
        </div>
    ) : (<></>)
}